<template>
    <div style="z-index: 999 !important;" class="under-development rounded " v-if="UNEDITABLE_STATUS.includes(_gHlp.getValue(product,'prod_main_status'))">
        <h3 :style="{'color': CASE_COLOR[_gHlp.getValue(product,'prod_main_status')]}">{{ _gHlp.getValue(product,'prod_main_status') }}</h3>
    </div>
</template>

<script>
import {CASE_COLOR} from '@/assets/js/colors.js'
import {UNEDITABLE_STATUS} from '@/assets/js/status.js'
export default {
    props: ['product'],
    data(){
        return{
            UNEDITABLE_STATUS:UNEDITABLE_STATUS,
            CASE_COLOR:CASE_COLOR
        }
    },
}
</script>
